import { Grid2 } from "@mui/material";
import React from "react";
import { useSearchParams } from "react-router";
import FormDropDown from "../../../../component/form/FormDropDown";
import FormTextField from "../../../../component/form/FormTextField";
import ManageDoctors from "../components/ManageDoctors";

export default function DeviceDetails({ control, watch }) {
  const [searchParams] = useSearchParams();
  const userParam = searchParams.get("user");
  const doctorParam = searchParams.get("doctor");
  const reasonForUsingEkko = watch("reasonForUsing");
  return (
    <>
      <ManageDoctors
        control={control}
        disabled={doctorParam && userParam ? true : false}
      />
      <Grid2 size={{ xs: 12, lg: 6 }}>
        <FormDropDown
          label="Dominant hand"
          fieldname="dominantHand"
          infoText="Dominant hand means the hand your child prefers to use for most activities."
          control={control}
          required
          dropdownValues={[
            { label: "Left", value: "Left" },
            { label: "Right", value: "Right" },
          ]}
        />
      </Grid2>
      {!userParam && (
        <>
          <Grid2 size={{ xs: 12, lg: 6 }}>
            <FormTextField
              placeholder="Device ID (Mentioned on device sticker)"
              label="EKKO Device ID"
              fieldname="deviceId"
              control={control}
              required={true}
            />
          </Grid2>
          <Grid2 size={{ xs: 12, lg: 6 }}>
            <FormDropDown
              label="Mobile device"
              fieldname="platform"
              control={control}
              required
              dropdownValues={[
                { label: "Android", value: "android" },
                { label: "iPhone", value: "iphone" },
                { label: "Both", value: "both" },
              ]}
            />
          </Grid2>
        </>
      )}
      <Grid2
        size={{ xs: 12 }}
        sx={{ display: "flex", flexDirection: "column", gap: 2 }}
      >
        <FormDropDown
          label="Reason (for using EKKO)"
          fieldname="reasonForUsing"
          control={control}
          required
          dropdownValues={[
            {
              label: "Speech Sound Disorders/Speech Delay",
              value: "Speech Sound Disorders/Speech Delay",
            },
            {
              label: "Dysarthria",
              value: "Dysarthria",
            },
            {
              label: "Selective Mutism",
              value: "Selective Mutism",
            },
            {
              label: "Autism",
              value: "Autism",
            },
            {
              label: "Apraxia",
              value: "Apraxia",
            },
            {
              label: "Delayed Milestones/Development Delays",
              value: "Delayed Milestones/Development Delays",
            },
            { label: "ADHD", value: "ADHD" },
            { label: "Behavioral Issues", value: "Behavioral Issues" },
            { label: "Other", value: "Other" },
          ]}
        />
      </Grid2>
      {reasonForUsingEkko === "Other" && (
        <Grid2 size={{ xs: 12 }}>
          <FormTextField
            placeholder="Please specify your reason"
            label="Other Reason"
            fieldname="otherReasonForUsingEkko"
            control={control}
            required={true}
          />
        </Grid2>
      )}
      <Grid2 size={12}>
        <FormTextField
          placeholder={
            userParam
              ? "Enter detailed disorder-related notes, diagnosis, or observations"
              : "Type any additional details"
          }
          label={
            userParam ? "Clinical / Disorder Description" : "Additional details"
          }
          multiline
          fieldname="additionalDetails"
          control={control}
          required={userParam ? true : false}
        />
      </Grid2>
      {!userParam && (
        <Grid2 size={12}>
          <FormTextField
            label="Clinician's recommended therapy plan"
            placeholder="Type your therapy plan here"
            multiline
            fieldname="recommendedPoints"
            control={control}
            required={true}
          />
        </Grid2>
      )}
    </>
  );
}
